import React from "react";
import SlackInvitationPost from "./SlackInvitationPost";
import WelcomeVideo from "./WelcomeVideo";
import "./WelcomePost.css";

const WelcomePost = (props) => {
  return (
    <section className="welcome-post">
      <SlackInvitationPost userName={props.userName} />
      <div className="welcome-video">
        <WelcomeVideo />
      </div>
    </section>
  );
};

export default WelcomePost;
